// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { IconClose } from 'components/atoms/icons/IconClose';
import { Modal } from 'components/atoms/Modal';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalType } from 'util/Enums';
import styles from './CreateUpdateRouteModal.module.scss';
import { baseRouteForm } from 'util/ConstantValues';
import CreateUpdateRouteForm from 'components/molecules/CreateUpdateRouteForm/CreateUpdateRouteForm';
import {
  getCollectRouteEmissionSites,
  getRouteCategories,
} from 'apis/collect_route';
import {
  RouteCreateEditModalType,
  RouteForm,
  RouteFormUpdate,
} from 'types/routeManagementTypes';
import { Option } from 'util/Types';
import { Suggestion } from 'components/molecules/InputDataListField';

interface Props {
  onClose: () => void;
  createUpdateModal: RouteCreateEditModalType;
  onSubmit: (routeForm: RouteForm | RouteFormUpdate, routeId?: number) => void;
}

const CreateUpdateRouteModal: React.FC<Props> = ({
  onClose,
  createUpdateModal,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [initValues, setInitValuesForm] = useState<RouteForm>(baseRouteForm);
  const { routeEditing } = createUpdateModal;

  const [collectionSiteOptions, setCollectionSiteOptions] = useState<Option[]>(
    []
  );
  const [routeCategories, setRouteCategories] = useState<Suggestion[]>([]);

  const handleSubmit = (
    createRouteForm: RouteForm | RouteFormUpdate,
    routeId?: number
  ) => {
    onSubmit(createRouteForm, routeId);
  };

  useEffect(() => {
    if (
      createUpdateModal.type === ModalType.update &&
      routeEditing?.id != null
    ) {
      const values: RouteForm = {
        ...baseRouteForm,
        name: routeEditing.name.trim(),
        category: routeEditing.category.trim(),
        siteId: routeEditing.siteId,
        driverIds: routeEditing.driverIds,
        materials: routeEditing.materials,
      };

      setInitValuesForm(values);
    }
  }, [createUpdateModal]);

  const getCollectionSites = async () => {
    await getCollectRouteEmissionSites({
      successCallback: (data) => {
        const options = data.sites.map((site) => ({
          label: site.name,
          value: site.id,
        }));
        setCollectionSiteOptions(options);
      },
      failedCallback: () => {
        setInitValuesForm(baseRouteForm);
        onClose?.();
      },
    });
  };

  const getCollectRouteCategories = async () => {
    await getRouteCategories({
      successCallback: (data) => {
        if (data.length === 0) {
          setRouteCategories([]);
          return;
        }

        setRouteCategories(
          data
            .filter(
              (item, index, self) =>
                index ===
                self.findIndex((t) => t.name.trim() === item.name.trim())
            )
            .map((item) => ({
              name: item.name.trim(),
            }))
        );
      },
      failedCallback: () => {
        setRouteCategories([]);
      },
    });
  };

  useEffect(() => {
    getCollectionSites();
    getCollectRouteCategories();
  }, []);

  return (
    <div className={styles.createRouteModal}>
      <Modal>
        <div className={styles.modalContent}>
          <div className={styles.customTitle}>
            <p className={styles.descriptionTitle}>
              {createUpdateModal.type === ModalType.add
                ? t('route_list.modal.title_add')
                : t('route_list.modal.title_edit')}
            </p>
            <div className={styles.top}>
              <IconClose onClick={onClose} />
            </div>
          </div>

          <CreateUpdateRouteForm
            initValues={initValues}
            createUpdateModal={createUpdateModal}
            collectionSiteOptions={collectionSiteOptions}
            routeCategories={routeCategories}
            onSubmit={handleSubmit}
            onClose={onClose}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CreateUpdateRouteModal;
